export default __webpack_public_path__ + "static/media/ezdoc_pro_logo_white.3b2b521c.png";